<template>
  <div class="main-content core-agent">
    <p class="title">2025年效果广告核心代理商</p>
    
    <div class="con-list-box">
      <div 
        class="con-item" 
        v-for="agent in agentList"
        :key="agent.companyName"
      >
        <p class="item-name">{{ agent.type }}</p>
        
        <div class="item-content">
          <img 
            class="item-logo" 
            :src="agent.logo"
          >
          
          <ul class="agent-info">
            <li class="agent-info-title">{{ agent.companyName }}</li>
            <li>{{ agent.contactName }} : {{ agent.contactMobile }}</li>
            <li>邮箱 : <br>{{ agent.contactEmail }}</li>
            <li>公司地址 : {{ agent.companyAddress }}</li>
            <li>
              公司官网 :
              <a 
                v-if="agent.companyNetwork" 
                :href="agent.companyNetwork" 
                target="_blank"
              >{{ agent.companyNetwork }}</a>
              <span v-else>无</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    
    <p class="desc">此排序不分先后</p>
  </div>
</template>
<script>
  export default {
    name: 'core-agent',
    data() {
      return {
        agentList: [
          {
            type: '社交汽车',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/weichuang.jpg',
            companyName: '北京微创时代广告有限公司',
            contactName: '宁海莹',
            contactMobile: '13810725446',
            contactEmail: 'ninghaiying@miage.com.cn',
            companyAddress: '北京市朝阳区安家楼路50号院A7-2',
            companyNetwork: 'http://www.leo.cn/'
          }, {
            type: '视频招聘',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/yyhl.jpg',
            companyName: '深圳优普联网络科技有限公司',
            contactName: '杨帆',
            contactMobile: '18511660751',
            contactEmail: 'yangfan@yoyohulian.com',
            companyAddress: '北京市朝阳区望京北路叶青大厦D201',
            companyNetwork: 'http://www.yoyoad.cn/'
          }, {
            type: 'LA电商生活',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/adks.jpg',
            companyName: '淮安爱德康赛广告有限公司',
            contactName: '李其童',
            contactMobile: '15611702048',
            contactEmail: 'liqitong@adks.cn',
            companyAddress: '北京朝阳区酒仙桥路10号恒通商务园(UB-P)B10座东区203室',
            companyNetwork: 'http://www.adks.cn/'
          }, {
            type: 'KA电商',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/lataxi.jpg',
            companyName: '北海拉塔西网络科技有限公司',
            contactName: '金瑶',
            contactMobile: '18301011655',
            contactEmail: 'jinyao@hljyer.com',
            companyAddress: '北京市朝阳区国樽赢地中心12层',
            companyNetwork: 'http://www.hljyer.com'
          },{
            type: '金融服务',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/qiyiguo.jpg',
            companyName: '广州奇异果互动科技股份有限公司',
            contactName: '何影利',
            contactMobile: '15112087573',
            contactEmail: 'yingli.he@mokiwi.com',
            companyAddress: '广州市海珠区琶洲大道109号铭丰广场A栋1304-1307室',
            companyNetwork: 'http://www.mokiwi.com'
          },{
            type: '工具信息',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/tianlong.jpg',
            companyName: '广东天龙科技集团股份有限公司',
            contactName: '王璟',
            contactMobile: '18901060066',
            contactEmail: 'jing.wang@kuaidaohd.com',
            companyAddress: '北京市朝阳区兆维工业园A1-1快道互动',
            companyNetwork: 'http://www.tloongroup.com/'
          },{
            type: '房产教育',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/myy.jpg',
            companyName: '上海美逸雅文化传媒有限公司',
            contactName: '刘佳',
            contactMobile: '13436670667',
            contactEmail: 'liujia@infinities.com.cn',
            companyAddress: '北京市海淀区宝盛南路1号院26号楼4层',
            companyNetwork: 'https://www.infinities.com.cn'
          },{
            type: '游戏行业',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/taige.jpg',
            companyName: '武汉泰舸网络科技有限公司',
            contactName: '刘宇',
            contactMobile: '18503047717',
            contactEmail: 'liuyu@tigecom.com',
            companyAddress: '北京市昌平区龙域北街金域国际中心B座608室',
            companyNetwork: 'http://www.tigecom.com'
          },{
            type: '游戏行业',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/wkhy.jpg',
            companyName: '欢聚时代文化传媒（北京）有限公司',
            contactName: '董绍辉',
            contactMobile: '13810788587',
            contactEmail: 'dongshaohui@gm825.com',
            companyAddress: '北京市朝阳区酒仙桥路10号恒通商务园B22座4层',
            companyNetwork: 'http://www.wankacn.com/'
          },{
            type: '资讯综合',
            logo: '//assets.cnbj1.mi-fds.com/assets/emi/index/agent/wabang.jpg',
            companyName: '哇棒移动传媒股份有限公司',
            contactName: '刘琼阳',
            contactMobile: '15510649791',
            contactEmail: 'liuqiongyang@wooboo.com.cn',
            companyAddress: '北京市东城区东四十条甲22号南新仓商务大厦B座11层1123',
            companyNetwork: 'http://www.wooboo.com.cn'
          }
        ]
      };
    },
  }
</script>
<style lang="scss">
@import "../assets/scss/core-agent.scss";
</style>